import { render, staticRenderFns } from "./ProductsOverview.vue?vue&type=template&id=3d8f7b13&scoped=true"
import script from "./ProductsOverview.vue?vue&type=script&lang=js"
export * from "./ProductsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f7b13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8f7b13')) {
      api.createRecord('3d8f7b13', component.options)
    } else {
      api.reload('3d8f7b13', component.options)
    }
    module.hot.accept("./ProductsOverview.vue?vue&type=template&id=3d8f7b13&scoped=true", function () {
      api.rerender('3d8f7b13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductsOverview.vue"
export default component.exports